//@ts-ignore
export default <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6260760584612029" crossorigin="anonymous"></script>